import React from 'react'
import SliderWithScrollLock from '#src/components/SliderWithScrollLock'
import { StarRating, Image } from '@deal/components'
import ReactMarkdown from 'react-markdown'
import carouselStyles from '#src/components/Carousel/styles.css'
import sa from './sa.png'
import styles from './styles.css'
import { formatDistance } from 'date-fns'
import { RoryReviewFragment } from '#src/generated/graphql'

interface Props {
  reviews: RoryReviewFragment[]
}

const Reviews: React.SFC<Props> = ({ reviews }) => {
  if (reviews.length < 4) {
    return null
  }

  return (
    <SliderWithScrollLock
      slidesToShow={1}
      slidesToScroll={1}
      infinite
      arrows={false}
      dots={true}
      className={styles.wrapper}
      dotsClass={carouselStyles.slickDots}
    >
      {reviews
        .filter(review => review.rating > 4)
        .map(({ id, rating, reviewedAt, comments, consumerLocation, consumerName }) => (
          <div key={id} className={styles.container}>
            <div className={styles.header}>
              <div className={styles.reviewTitle}>
                <StarRating rating={rating} />
                <div className={styles.nameContainer}>
                  <div className={styles.firstName}>{consumerName}</div>
                  <div className={styles.time}>
                    - {formatDistance(reviewedAt, new Date())}, {consumerLocation}
                  </div>
                </div>
              </div>
              <div className={styles.verified}>
                <Image src={sa} width={15} />
                <div className={styles.verifiedText}>Verified purchase</div>
              </div>
            </div>
            <ReactMarkdown source={comments || ''} className={styles.body} />
          </div>
        ))}
    </SliderWithScrollLock>
  )
}

export default Reviews
